import VCheckbox from 'vuetify/lib/components/VCheckbox/VCheckbox';

const CheckEditor = VCheckbox.extend({
  props: {
    falseValue: 0,
    trueValue: 1
  }
})

export default {
  install: function (Vue) {
    Vue.component('check-editor', CheckEditor)
  }
}